import { Stack, type StackProps } from "@mui/material";
import { Editor } from "@styleguide";
import { useModalOfferContext } from "../context";

export const DescriptionInput = (props: StackProps) => {
  const { offer, setOffer, disabled } = useModalOfferContext();

  return (
    <Stack {...props}>
      <Editor
        id="offer-description"
        output="html"
        value={offer.description}
        onChange={(value: string) => {
          if (value !== offer.description) {
            setOffer((offer) => ({ ...offer, description: value }));
          }
        }}
        disabled={disabled}
        height={194}
        maxHeight={194}
        fullWidth
      />
    </Stack>
  );
};
